export type Feature = {
   id: string;
   display: string;
   deprecated: boolean;
   cloudStorage: boolean;
};

const feature = (
   id: string,
   display: string,
   deprecated: boolean,
   cloudStorage: boolean
): Feature => ({id, display, deprecated, cloudStorage});

export const DiplomatFeature = {
   ADDITIONAL_ARCHIVE: feature('ADDITIONAL_ARCHIVE', 'Additional Archive', false, false),
   ADVANCED_REPORTING: feature('ADVANCED_REPORTING', 'Advanced Reporting', false, false),
   ADVANCED_TROUBLESHOOTING: feature(
      'ADVANCED_TROUBLESHOOTING',
      'Advanced Troubleshooting',
      false,
      false
   ),
   AEKS: feature('AEKS', 'Additional Encryption Keys', false, false),
   ALL_CLOUDS: feature('ALL_CLOUDS', 'All Cloud Storage Transports', false, false),
   AMAZONS3_TRANSPORT: feature('AMAZONS3_TRANSPORT', 'Amazon S3 Transport', false, true),
   API: feature('API', 'API', false, false),
   ARCHIVE_ADMIN: feature('ARCHIVE_ADMIN', 'Archive Admin', false, false),
   ARCHIVE_FILE_CHOICE: feature('ARCHIVE_FILE_CHOICE', 'Archive File Choice', false, false),
   ARCHIVING: feature('ARCHIVING', 'Archiving', false, false),
   AUDIT_CRITICAL: feature('AUDIT_CRITICAL', 'Audit Critical', false, false),
   AUDIT_TRAIL: feature('AUDIT_TRAIL', 'Audit Trail', false, false),
   AUTHENTICATED_LOGIN: feature('AUTHENTICATED_LOGIN', 'Authenticated Login', true, false), //deprecated in v5.0
   AZURE_TRANSPORT: feature('AZURE_TRANSPORT', 'Azure Storage Transport', false, true),
   BACKUP_RESTORE: feature('BACKUP_RESTORE', 'Backup & Restore', false, false),
   BACKUP_SETTINGS: feature('BACKUP_SETTINGS', 'Backup Settings', false, false),
   BOX_TRANSPORT: feature('BOX_TRANSPORT', 'Box Transport', false, true),
   BUSINESS_USER_EMAIL: feature('BUSINESS_USER_EMAIL', 'Business User Email', false, false),
   CLOUD_TRANSPORT: feature('CLOUD_TRANSPORT', 'Diplomat Remote Agent', false, false),
   COMMAND_LINE_INTERFACE: feature(
      'COMMAND_LINE_INTERFACE',
      'Command Line Interface',
      false,
      false
   ),
   COPY_NUMBER: feature('COPY_NUMBER', 'Copy Number', false, false),
   DATA_AGENT_TRANSPORT: feature('DATA_AGENT_TRANSPORT', 'Data Agent Transport', true, false), //deprecated
   DATE_AND_SEQUENCE_PARAMETERS: feature(
      'DATE_AND_SEQUENCE_PARAMETERS',
      'Date & Seq Parameters',
      false,
      false
   ),
   DEFAULT_TRANS_SETTINGS: feature(
      'DEFAULT_TRANS_SETTINGS',
      'Default Trans Settings',
      false,
      false
   ),
   DELAY_JOBS: feature('DELAY_JOBS', 'Delay Jobs', false, false),
   DELETE_ARCHIVE_DEFAULT: feature(
      'DELETE_ARCHIVE_DEFAULT',
      'Delete Archive By Default',
      false,
      false
   ),
   DROPBOX_TRANSPORT: feature('DROPBOX_TRANSPORT', 'Dropbox Transport', false, true),
   EMAIL_TRANSPORT: feature('EMAIL_TRANSPORT', 'Email Transport', false, false),
   EXPLICIT_FTP_TIMEOUT: feature('EXPLICIT_FTP_TIMEOUT', 'Explicit FTP Timeout', true, false), //deprecated
   FILE_INTEGRITY_CHECK: feature('FILE_INTEGRITY_CHECK', 'File Integrity Check', false, false),
   FILESYSTEM_MONITOR_SCHEDULING: feature(
      'FILESYSTEM_MONITOR_SCHEDULING',
      'File System Monitor',
      false,
      false
   ),
   FTP_SERVER_ADMIN: feature('FTP_SERVER_ADMIN', 'FTP Server Admin', false, false),
   FTP_SETTINGS: feature('FTP_SETTINGS', 'FTP Settings', false, false),
   FTP_TRANSPORT: feature('FTP_TRANSPORT', 'FTP Transport', false, false),
   GOOGLE_CLOUD_TRANSPORT: feature('GOOGLE_CLOUD_TRANSPORT', 'Google Cloud Transport', false, true),
   HIGH_PRIORITY_JOBS: feature('HIGH_PRIORITY_JOBS', 'High Priority Jobs', false, true),
   HOLIDAY_CALENDAR: feature('HOLIDAY_CALENDAR', 'Holiday Calendar', false, false),
   HTTP_TRANSPORT: feature('HTTP_TRANSPORT', 'HTTP Transport', false, false),
   IT_EMAIL: feature('IT_EMAIL', 'IT Email', false, false),
   JOB_HISTORY: feature('JOB_HISTORY', 'Job History', false, false),
   JOB_MONITOR: feature('JOB_MONITOR', 'Job Monitor', false, false),
   JOB_QUEUE_CONTROL: feature('JOB_QUEUE_CONTROL', 'Job Queue Control', false, false),
   JOB_STATUS_INDICATION: feature('JOB_STATUS_INDICATION', 'Job Status Indication', false, false),
   JOB_SUSPENSION: feature('JOB_SUSPENSION', 'Job Suspension', false, false),
   KEY_RECOVERY: feature('KEY_RECOVERY', 'Key Recovery', false, false),
   KEY_RING_IMPORTING: feature('KEY_RING_IMPORTING', 'Key Ring Importing', false, false),
   LOG_FILE_ADMIN: feature('LOG_FILE_ADMIN', 'Log File Admin', false, false),
   LOG_FILE_MAINTENANCE: feature('LOG_FILE_MAINTENANCE', 'Log File Maintenance', false, false),
   MERGE: feature('MERGE', 'Merge', false, false),
   MOVE: feature('MOVE', 'Move', false, false),
   MULTIPLE_FILENAME_FIELDS: feature(
      'MULTIPLE_FILENAME_FIELDS',
      'Multiple Filename Fields',
      false,
      false
   ),
   ORACLE_CLOUD_TRANSPORT: feature('ORACLE_CLOUD_TRANSPORT', 'Oracle Cloud Transport', false, true),
   PAGING: feature('PAGING', 'Paging', false, false),
   PARTNERS: feature('PARTNERS', 'Partners', false, false),
   PRE_POST_COMMANDS: feature('PRE_POST_COMMANDS', 'Pre/Post Commands', false, false),
   PROXY_SERVER: feature('PROXY_SERVER', 'Proxy Server', false, false),
   REPORTING: feature('REPORTING', 'Reporting', false, false),
   RESTORE_CONFIG: feature('RESTORE_CONFIG', 'Restore Config Settings', false, false),
   RETAIN_MODIFIED_DATE: feature('RETAIN_MODIFIED_DATE', 'Retain Modified Date', false, false),
   REVIEWER_USERS: feature('REVIEWER_USERS', 'Reviewer Users', false, false),
   SEARCH: feature('SEARCH', 'Search', false, false),
   SELECTIVE_MERGE: feature('SELECTIVE_MERGE', 'Selective Merge', false, false),
   SHAREFILE_TRANSPORT: feature('SHAREFILE_TRANSPORT', 'ShareFile Transport', false, true),
   SMB_TRANSPORT: feature('SMB_TRANSPORT', 'SMB Transport', false, false),
   SQL_AUDIT_TRAIL: feature('SQL_AUDIT_TRAIL', 'SQL Audit Trail', false, false),
   SSH_KEYS: feature('SSH_KEYS', 'SSH Keys', false, false),
   SSL_CERTIFICATES: feature('SSL_CERTIFICATES', 'SSL Certificates', false, false),
   STATUS_DIALOG: feature('STATUS_DIALOG', 'Status Dialog', false, false),
   SUBKEY_ADDITION: feature('SUBKEY_ADDITION', 'Subkey Addition', false, false),
   THIRD_PARTY_SCHEDULING: feature(
      'THIRD_PARTY_SCHEDULING',
      'Third Party Scheduling',
      false,
      false
   ),
   TRANSLATE_INVALID_CHARS: feature(
      'TRANSLATE_INVALID_CHARS',
      'Translate Invalid Chars',
      false,
      false
   ),
   USE_TEMP_FILENAMES: feature('USE_TEMP_FILENAMES', 'Use Temp Filenames', false, false),
   USER_ACTIVITY: feature('USER_ACTIVITY', 'User Activity', false, false),
   USER_ADMIN: feature('USER_ADMIN', 'User Admin', false, false),
   ZIP: feature('ZIP', 'Zip', false, false),
   AS2_TRANSPORT: feature('AS2_TRANSPORT', 'AS2 Transport', false, false),
   FILE_TRIGGER: feature('FILE_TRIGGER', 'File Triggers', false, false),
   SOURCE_FILE_MOVE: feature('SOURCE_FILE_MOVE', 'Source File Move', false, false),
   GOOGLE_CLOUDHEALTH_API: feature(
      'GOOGLE_CLOUDHEALTH_API',
      'Google Cloud Health API',
      false,
      true
   ),
   SFTP_SERVER: feature('SFTP_SERVER', 'SFTP_SERVER', false, false),
   FILE_QUIESCENCE: feature('FILE_QUIESCENCE', 'FILE_QUIESCENCE', false, false),
   BISCOM: feature('BISCOM', 'Biscom Transport', false, true),
   SYNCHRONIZATION: feature('SYNCHRONIZATION', 'Synchronization', false, false),
   MULTIPLE_DESTINATIONS: feature('MULTIPLE_DESTINATIONS', 'MULTIPLE_DESTINATIONS', false, false),
   EDGE_GATEWAY: feature('EDGE_GATEWAY', 'EDGE_GATEWAY', false, false),
   LDAP: feature('LDAP_AUTHENTICATION', 'LDAP_AUTHENTICATION', false, false),
   SHAREPOINT: feature('SHAREPOINT', 'SharePoint Transport', false, false),
   ONEDRIVE: feature('ONEDRIVE', 'OneDrive Transport', false, false),
   ROI_REPORT: feature('ROI_REPORT', 'ROI Reports', false, false),
   CONNECTION_MAP: feature('CONNECTION_MAP', 'Connection Map', false, false),
   SAML_SSO: feature('SAML_SSO', 'SAML SSO', false, false),
   THREAT_INTELLIGENCE: feature('THREAT_INTELLIGENCE', 'Threat Intelligence', false, false),
   WORKDRIVE: feature('WORKDRIVE', 'Zoho WorkDrive Transport', false, false),
   WEB_CLIENT: feature('WEB_CLIENT', 'Web Transfer Client', false, false),
   WEB_CLIENT_PGP: feature('WEB_CLIENT_PGP', 'Enforce PGP in Web Transfer Client', false, false),
   ADMIN_TOTP: feature('ADMIN_TOTP', 'Admin TOTP', false, false),
};
